import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import { catchError, Observable } from 'rxjs';
import { LoginResponse } from '../interfaces/LoginResponse';
import { environment } from '../../environments/environment';
import { Record } from '../interfaces/Record';
import { ServerResponse } from '../interfaces/ServerResponse';
import { NotifyDialogService } from './notify-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class Neo4jGeneratorService {

  API_URL = environment.API_URL;

  constructor(private http: HttpClient, public shared: SharedService, private notifyDialogService: NotifyDialogService) { }

  createNode(node_name: string, hierarchy_name: string): Observable<ServerResponse<Record>> {
    if(!this.shared.data_service)return this.notifyDialogService.openDialog("No Dataservice", "No Dataservice present, contact support team");
    let url = `${this.API_URL}/creator/functions/add_node`;
    return this.http.post<ServerResponse<Record>>(url, {
      string_connection: this.shared.data_service.string_connection,
      node_name,
      hierarchy_name
    })
  }

  createNestedNode(father_label: string, father_uuid: string, node_name: string): Observable<ServerResponse<Record>> {
    if(!this.shared.data_service)return this.notifyDialogService.openDialog("No Dataservice", "No Dataservice present, contact support team");
    let url = `${this.API_URL}/creator/functions/add_nested_node`;
    return this.http.post<ServerResponse<Record>>(url, {
      string_connection: this.shared.data_service.string_connection,
      father_label,
      father_uuid,
      node_name
    })
  }

  addNodeShapeOrIcon(node_label: string, node_uuid: string, shapeicon_label: string, shapeicon_uuid: string): Observable<ServerResponse<Record>> {
    if(!this.shared.data_service)return this.notifyDialogService.openDialog("No Dataservice", "No Dataservice present, contact support team");
    let url = `${this.API_URL}/creator/functions/node_shape_icon`;
    return this.http.post<ServerResponse<Record>>(url, {
      string_connection: this.shared.data_service.string_connection,
      node_label,
      node_uuid,
      shapeicon_label,
      shapeicon_uuid
    })
  }

  addFlowRelationship(source_label: string, source_uuid: string, target_label: string, target_uuid: string): Observable<ServerResponse<Record>> {
    if(!this.shared.data_service)return this.notifyDialogService.openDialog("No Dataservice", "No Dataservice present, contact support team");
    let url = `${this.API_URL}/creator/functions/add_flow_relationship`;
    return this.http.post<ServerResponse<Record>>(url, {
      string_connection: this.shared.data_service.string_connection,
      source_label,
      source_uuid,
      target_label,
      target_uuid
    })
  }

  removeFlowRelationship(
    source_label: string,
    source_uuid: string,
    target_label: string,
    target_uuid: string, 
    relationship_type: string,
    relationship_uuid: string
  ): Observable<ServerResponse<Record>> {
    if(!this.shared.data_service)return this.notifyDialogService.openDialog("No Dataservice", "No Dataservice present, contact support team");
    let url = `${this.API_URL}/creator/functions/remove_flow_relationship`;
    return this.http.post<ServerResponse<Record>>(url, {
      string_connection: this.shared.data_service.string_connection,
      source_label,
      source_uuid,
      target_label,
      target_uuid,
      relationship_type,
      relationship_uuid
    })
  }

  deleteNode(node_label: string, node_uuid: string): Observable<ServerResponse<Record>> {
    if(!this.shared.data_service)return this.notifyDialogService.openDialog("No Dataservice", "No Dataservice present, contact support team");
    let url = `${this.API_URL}/creator/functions/delete_node_container`;
    return this.http.post<ServerResponse<Record>>(url, {
      string_connection: this.shared.data_service.string_connection,
      node_label,
      node_uuid
    })
  }

  addNodeProperty(
    node_label: string,
    node_uuid: string,
    property_name: string,
    property_value: string, 
  ): Observable<ServerResponse<Record>> {
    if(!this.shared.data_service)return this.notifyDialogService.openDialog("No Dataservice", "No Dataservice present, contact support team");
    let url = `${this.API_URL}/creator/functions/add_node_property`;
    return this.http.post<ServerResponse<Record>>(url, {
      string_connection: this.shared.data_service.string_connection,
      node_label,
      node_uuid,
      property_name,
      property_value
    })
  }

  addRelationshipProperty(
    source_label: string,
    source_uuid: string,
    target_label: string,
    target_uuid: string, 
    relationship_type: string,
    relationship_uuid: string,
    property_name: string,
    property_value: string
  ): Observable<ServerResponse<Record>> {
    if(!this.shared.data_service)return this.notifyDialogService.openDialog("No Dataservice", "No Dataservice present, contact support team");
    let url = `${this.API_URL}/creator/functions/add_relationship_property`;
    return this.http.post<ServerResponse<Record>>(url, {
      string_connection: this.shared.data_service.string_connection,
      source_label,
      source_uuid,
      target_label,
      target_uuid,
      relationship_type,
      relationship_uuid,
      property_name,
      property_value
    })
  }

  changeNodeFather(
    hierarchy_name: string,
    label_new_father: string,
    uuid_new_father: string,
    label_node_moving: string, 
    uuid_node_moving: string,
  ): Observable<ServerResponse<Record>> {
    if(!this.shared.data_service)return this.notifyDialogService.openDialog("No Dataservice", "No Dataservice present, contact support team");
    let url = `${this.API_URL}/creator/functions/changing_of_father_node`;
    return this.http.post<ServerResponse<Record>>(url, {
      string_connection: this.shared.data_service.string_connection,
      hierarchy_name,
      label_new_father,
      uuid_new_father,
      label_node_moving,
      uuid_node_moving
    })
  }
}
